/* eslint-disable consistent-return */
import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

const highlightCss = {
  fontWeight: 'bold',
  backgroundColor: '#FFCCD7',
};

export const Value = styled.span(() =>
  mq({
    display: 'inline-block',
    padding: '0 2px',
  }),
);

export const LargestValue = styled(Value)(() =>
  mq({
    ...highlightCss,
    color: defaultTheme.color.primary,
  }),
);

export const SecondLargestValue = styled(Value)(() =>
  mq({
    ...highlightCss,
    color: defaultTheme.color.secondary,
  }),
);
